import { Controller, useFormContext } from "react-hook-form";
import { FormFeedback, FormGroup } from "reactstrap";
import SearchableSelect from "../../../CommonElements/SearchableSelect";
import styled from "styled-components";

const FormSelectAppearance = styled.div`
  label {
    color: inherit;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 8px;
  }

  button[aria-haspopup="listbox"] {
    min-height: 47px;
    padding: 10px 12px;
    border-color: #dee2e6;
    border-radius: 5px;
  }

  button[aria-haspopup="listbox"] > span:first-child {
    font-size: 14px;
    font-weight: 400;
  }

  button[aria-haspopup="listbox"][aria-expanded="true"] {
    border-color: var(--search-select-focus-border);
  }

  body.dark-only & button[aria-haspopup="listbox"]:not([aria-expanded="true"]) {
    border-color: var(--search-select-border);
  }
`;

type Props = {
  name: string;
  label?: string;
  options: { value: string; label: string; disabled?: boolean }[];
  placeholder?: string;
  disabled?: boolean;
  className?: string;
};

const RHFSearchableSelect = ({ name, label, options, placeholder, disabled, className }: Props) => {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <FormGroup className={className}>
          <FormSelectAppearance>
            <SearchableSelect
              name={name}
              label={label}
              value={field.value ?? ""}
              options={options}
              onChange={(value) => field.onChange(value)}
              placeholder={placeholder}
              disabled={disabled}
            />
          </FormSelectAppearance>
          {fieldState.error && <FormFeedback className="d-block">{fieldState.error.message}</FormFeedback>}
        </FormGroup>
      )}
    />
  );
};

export default RHFSearchableSelect;
